/* Free Life Labs — mobile menu v2 (LIVE on mobile <=989px since Oct 20, 2026).
   ?menu=off falls back to the theme's original drawer for that tab.
   Builds a new drawer from the theme's existing drawer links, so every link
   and destination (including the wholesale menu) stays the same. */
(function () {
  var KEY = 'fllMenuV2';
  var me = document.currentScript;
  // LIVE for all mobile visitors. Opt-out: ?menu=off (kept for the tab via sessionStorage); ?menu=v2 clears the opt-out.
  try {
    var q = new URLSearchParams(location.search).get('menu');
    if (q === 'off') sessionStorage.setItem(KEY, 'off');
    if (q === 'v2' || q === 'on') sessionStorage.removeItem(KEY);
    if (sessionStorage.getItem(KEY) === 'off') return;
  } catch (e) {}

  var MQ = window.matchMedia('(max-width: 989px)');
  var BASE = (me && me.getAttribute('data-assets')) || '';
  var WHOLESALE = !!(me && me.getAttribute('data-wholesale') === '1') || !!(window.FLL_WHOLESALE_ITEMS && window.FLL_WHOLESALE_ITEMS.length);

  // Styles load only at mobile widths, so desktop visitors get nothing extra.
  var cssDone = false;
  function loadCss() {
    if (cssDone || !MQ.matches) return;
    cssDone = true;
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = me.getAttribute('data-css');
    document.head.appendChild(css);
    document.documentElement.classList.add('fll-mm2-on');
  }
  loadCss();
  if (MQ.addEventListener) MQ.addEventListener('change', loadCss);

  var CATS = {
    nerve: { ink: '#457D26', wash: '#F3F8EE', line: '#CBE1B7' },
    skin:  { ink: '#16668F', wash: '#EEF6FB', line: '#BBDCEF' },
    wound: { ink: '#196649', wash: '#EDF5F1', line: '#BCDBCB' },
    glp:   { ink: '#16456B', wash: '#EEF2F7', line: '#C3D3E1' }
  };
  function catOf(s) {
    s = (s || '').toLowerCase();
    if (/nerve|neuropath|pain/.test(s)) return 'nerve';
    if (/derm|skin/.test(s)) return 'skin';
    if (/wound/.test(s)) return 'wound';
    if (/glp|peptalyn/.test(s)) return 'glp';
    return '';
  }
  function thumbOf(s) {
    s = (s || '').toLowerCase();
    if (/pain|cream/.test(s)) return 'fll-pv2-pc.webp';
    if (/nerve|neuropath/.test(s)) return 'fll-pv2-nc.webp';
    if (/derm/.test(s)) return 'fll-pv2-dm.webp';
    if (/gel/.test(s)) return 'fll-pv2-wg.webp';
    if (/wound/.test(s)) return 'fll-pv2-ww.webp';
    if (/peptalyn|glp/.test(s)) return 'peptalyn-bottle-cutout-v3.webp';
    return '';
  }
  function esc(v) {
    return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  // Ben's rule: never show subscription wording to wholesale customers.
  function clean(s) { return WHOLESALE ? s.replace(/\s*[·|-]?\s*(subscribe\s*&?\s*save|subscription)[^·|]*/ig, '').trim() : s; }

  var ARROW = '<svg class="fll-mm2__chev" viewBox="0 0 16 16" aria-hidden="true"><path d="M6 3.5 10.5 8 6 12.5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var PLUS = '<svg class="fll-mm2__plus" viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 6 8 10.5 12.5 6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function source() { return document.querySelector('#menu-drawer .menu-drawer__menu'); }
  function directChild(el, sel) {
    for (var i = 0; i < el.children.length; i++) if (el.children[i].matches(sel)) return el.children[i];
    return null;
  }

  // ---- read the existing drawer into a plain tree ----
  function readList(ul) {
    var out = [];
    for (var i = 0; i < ul.children.length; i++) {
      var li = ul.children[i];
      if (li.hasAttribute('data-fll-order-item')) continue;
      var det = directChild(li, 'details');
      var a = directChild(li, 'a');
      if (det) {
        var sub = det.querySelector('.menu-drawer__submenu ul, ul');
        out.push({ title: txt(directChild(det, 'summary')), children: sub ? readList(sub) : [], wholesaleList: sub && sub.hasAttribute('data-fll-wholesale') ? sub : null });
      } else if (a && a.querySelectorAll(':scope > span').length > 1) {
        var sp = a.querySelectorAll(':scope > span');
        out.push({ title: clean(txt(sp[0])), url: a.getAttribute('href'), price: clean(txt(sp[1])) });
      } else if (a) {
        out.push({ title: clean(txt(a)), url: a.getAttribute('href') });
      } else {
        // wholesale-injected rows: a group label <div> or an <a> with title + price spans
        var lab = li.querySelector(':scope > div');
        var wa = li.querySelector(':scope > a');
        if (wa) {
          var spans = wa.querySelectorAll('span');
          out.push({ title: txt(spans[0]) || txt(wa), url: wa.getAttribute('href'), price: spans[1] ? clean(txt(spans[1])) : '' });
        } else if (lab) out.push({ label: txt(lab) });
      }
    }
    return out;
  }

  var CATNAME = { nerve: 'Nerve Health', skin: 'Skin Care', wound: 'Wound Care', glp: 'GLP-1 Support' };
  // One-line benefits, taken from the product pages' own headlines.
  function benefitOf(s) {
    s = (s || '').toLowerCase();
    if (/pain|cream/.test(s)) return 'Fast-acting topical relief';
    if (/nerve|neuropath/.test(s)) return 'Supports nerve health';
    if (/derm/.test(s)) return 'For dry, cracked heels';
    if (/gel/.test(s)) return 'Nano-silver wound care';
    if (/wound|surgery/.test(s)) return 'Nutrition for surgery recovery';
    if (/peptalyn|glp/.test(s)) return 'Built for GLP-1 users';
    return '';
  }
  // Best seller: top retail product by units, last 90 days (Jul 22 - Oct 19, 2026), from Admin API orders.
  // NerveReverse Neuropathy Support Formula: 223 units / 208 orders (next: Pain Cream 39 units). Hidden for wholesale.
  var BEST = 'nervereverse-neuropathy-support-formula';

  function productTile(it, group, idx) {
    var k = catOf((it.url || '') + ' ' + it.title + ' ' + (group || '')) || 'glp';
    var c = CATS[k];
    var img = thumbOf((it.url || '') + ' ' + it.title);
    var m = it.title.match(/\((pre-?order[^)]*)\)/i);
    var title = it.title.replace(/\s*\((pre-?order[^)]*)\)\s*/i, '');
    var gname = (group || '').replace(/\s*\((pre-?order[^)]*)\)\s*/i, '') || CATNAME[k];
    var best = !WHOLESALE && (it.url || '').indexOf('/products/' + BEST) !== -1;
    return '<li style="--i:' + idx + '"><a class="fll-mm2__tile" href="' + esc(it.url) + '" style="--ink:' + c.ink + ';--wash:' + c.wash + ';--line:' + c.line + '">' +
      '<span class="fll-mm2__img">' + (img ? '<img src="' + esc(BASE + img) + '" alt="" loading="lazy">' : '') + '</span>' +
      (best ? '<span class="fll-mm2__cat"><span class="fll-mm2__best">Best seller</span></span>' : '<span class="fll-mm2__cat"><span class="fll-mm2__dot"></span>' + esc(gname) + '</span>') +
      '<span class="fll-mm2__pname">' + esc(title) + '</span>' +
      (benefitOf((it.url || '') + ' ' + it.title) ? '<span class="fll-mm2__benefit">' + esc(benefitOf((it.url || '') + ' ' + it.title)) + '</span>' : '') +
      (m ? '<span class="fll-mm2__badge">' + esc(m[1]) + '</span>' : '') +
      (it.price ? '<span class="fll-mm2__price">' + esc(it.price) + '</span>' : '') +
      '</a></li>';
  }

  function productsSection(node) {
    var items = [], rest = '', g = '';
    node.children.forEach(function (n) {
      if (n.label !== undefined) g = n.label;
      else if (n.children) n.children.forEach(function (x) { if (x.url) items.push([x, n.title]); });
      else if (n.url && node.children.some(function (z) { return z.label !== undefined; })) items.push([n, g]);
      else if (n.url) rest = '<a class="fll-mm2__all" href="' + esc(n.url) + '">' + esc(n.title) + ARROW + '</a>';
    });
    return '<section class="fll-mm2__products" aria-label="' + esc(node.title) + '">' +
      '<div class="fll-mm2__sechead"><p class="fll-mm2__eyebrow">' + esc(node.title) + '</p>' + rest + '</div>' +
      '<ul class="fll-mm2__grid">' + items.map(function (p, i) { return productTile(p[0], p[1], i); }).join('') + '</ul></section>';
  }

  function accordion(node) {
    return '<details class="fll-mm2__acc"><summary>' + esc(node.title) + PLUS + '</summary><div class="fll-mm2__accbody"><ul>' +
      node.children.filter(function (c) { return c.url; }).map(function (c) {
        return '<li><a href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>';
      }).join('') + '</ul></div></details>';
  }

  var root, panel, lastFocus, scrollY = 0;

  function build() {
    var src = source();
    if (!src) return false;
    var tree = readList(src);
    // Find a Clinic (PREVIEW: only with ?menu=clinic; go-live sets FLL_CLINIC = true)
    var FLL_CLINIC = true;
    if (FLL_CLINIC) tree.forEach(function (n) {
      if (!n.children || !/^(about|why free life labs)$/i.test((n.title || '').trim())) return;
      if (n.children.some(function (c) { return c.url && c.url.indexOf('find-a-clinic') !== -1; })) return;
      var at = -1; n.children.forEach(function (c, i) { if (c.url && /testimonial/i.test(c.url)) at = i; });
      var it = { title: 'Find a Clinic', url: '/pages/find-a-clinic' };
      if (at > -1) n.children.splice(at + 1, 0, it); else n.children.push(it);
    });
    // Contact Us removed from header (PREVIEW: only with ?menu=contact; go-live sets FLL_CONTACT_FOOTER = true)
    var FLL_CONTACT_FOOTER = true;
    if (FLL_CONTACT_FOOTER) tree = tree.filter(function (n) { return !/^contact/i.test((n.title || '').trim()); });
    var orderA = document.querySelector('[data-fll-order]');
    var order = orderA ? orderA.getAttribute('href') : null;
    var products = '', links = '', accs = '';
    tree.forEach(function (n) {
      if (n.children && /product/i.test(n.title)) products = productsSection(n);
      else if (n.children) accs += accordion(n);
      else if (n.url) links += '<li><a class="fll-mm2__link" href="' + esc(n.url) + '">' + esc(n.title) + ARROW + '</a></li>';
    });
    if (!order) {
      var all = tree.filter(function (n) { return n.children && /product/i.test(n.title); })[0];
      var allA = all && all.children.filter(function (c) { return c.url && /all/i.test(c.title); })[0];
      order = allA ? allA.url : '/collections/all';
    }

    // account link from the original drawer utility area
    var acct = document.querySelector('#menu-drawer .menu-drawer__account');
    var acctHref = acct ? acct.getAttribute('href') : '/account';
    var acctLabel = acct ? txt(acct) : 'Account';
    var cartBtn = document.getElementById('cart-icon-bubble');
    var cartCount = cartBtn ? txt(cartBtn.querySelector('.cart-count-bubble span[aria-hidden]')) : '';
    var socials = document.querySelector('#menu-drawer .list-social');

    var logo = document.querySelector('.header__heading-logo');
    var ship = WHOLESALE ? 'Free shipping over $750' : 'Free shipping on all orders';

    root = document.createElement('div');
    root.className = 'fll-mm2';
    root.setAttribute('hidden', '');
    root.innerHTML =
      '<div class="fll-mm2__backdrop" data-mm2-close></div>' +
      '<div class="fll-mm2__panel" role="dialog" aria-modal="true" aria-label="Menu" tabindex="-1">' +
        '<div class="fll-mm2__top">' +
          (logo ? '<a href="/" class="fll-mm2__logo"><img src="' + esc(logo.currentSrc || logo.src) + '" alt="Free Life Labs"></a>' : '<span class="fll-mm2__title">Menu</span>') +
          '<button type="button" class="fll-mm2__x" data-mm2-close aria-label="Close menu"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 5l10 10M15 5 5 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>' +
        '</div>' +
        '<div class="fll-mm2__scroll">' +
          '<a class="fll-mm2__cta" href="' + esc(order) + '">Order Products' + ARROW + '</a>' +
          products +
          '<nav class="fll-mm2__nav" aria-label="More"><ul>' + links + '</ul>' + accs + '</nav>' +
          '<ul class="fll-mm2__trust"><li>' + esc(ship) + '</li><li>Formulated and Manufactured in the USA</li></ul>' +
          (socials ? '<div class="fll-mm2__social">' + socials.outerHTML + '</div>' : '') +
        '</div>' +
        '<div class="fll-mm2__foot">' +
          '<a class="fll-mm2__util" href="' + esc(acctHref) + '"><svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="7" r="3.4" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M3.8 17c.8-3.2 3.3-5 6.2-5s5.4 1.8 6.2 5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' + esc(acctLabel) + '</a>' +
          '<button type="button" class="fll-mm2__util fll-mm2__util--cart" data-mm2-cart><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 6h12l-1 11H5L4 6Z M7 6V5a3 3 0 0 1 6 0v1" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>Cart<span class="fll-mm2__count"' + (cartCount && cartCount !== '0' ? '' : ' hidden') + ' aria-label="items in cart">' + esc(cartCount) + '</span></button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);
    panel = root.querySelector('.fll-mm2__panel');

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-mm2-close]')) { e.preventDefault(); close(); return; }
      if (e.target.closest('[data-mm2-cart]')) {
        e.preventDefault();
        close(true);
        var c = document.getElementById('cart-icon-bubble');
        if (c) setTimeout(function () { c.click(); }, 60);
        return;
      }
      var a = e.target.closest('a[href]');
      if (a) unlock(); // let navigation proceed with normal scroll
    });
    // smooth accordion height
    root.querySelectorAll('.fll-mm2__acc > summary').forEach(function (s) {
      s.addEventListener('click', function (e) {
        var d = s.parentElement, body = d.querySelector('.fll-mm2__accbody');
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        e.preventDefault();
        if (d.open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(function () { body.style.height = '0px'; });
          body.addEventListener('transitionend', function f() { body.removeEventListener('transitionend', f); d.open = false; body.style.height = ''; }, { once: true });
        } else {
          d.open = true;
          body.style.height = '0px';
          requestAnimationFrame(function () { body.style.height = body.scrollHeight + 'px'; });
          body.addEventListener('transitionend', function f() { body.style.height = ''; }, { once: true });
        }
      });
    });
    return true;
  }

  // ---------- live cart count ----------
  function setCount(n) {
    if (!root) return;
    var el = root.querySelector('.fll-mm2__count');
    if (!el) return;
    el.textContent = n > 99 ? '99+' : String(n);
    el.hidden = !(n > 0);
  }
  function refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count || 0); }).catch(function () {});
  }
  try {
    if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refreshCart(); });
  } catch (e) {}
  if (window.fetch && !window.fetch.__fllMm2) {
    var _f = window.fetch;
    var wrapped = function (input) {
      var p = _f.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(refreshCart, 50); }, function () {});
      } catch (e) {}
      return p;
    };
    wrapped.__fllMm2 = true;
    window.fetch = wrapped;
  }

  function lock() {
    scrollY = window.scrollY;
    document.documentElement.classList.add('fll-mm2-lock');
    document.body.style.top = -scrollY + 'px';
  }
  function unlock() {
    if (!document.documentElement.classList.contains('fll-mm2-lock')) return;
    document.documentElement.classList.remove('fll-mm2-lock');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }
  function isOpen() { return root && root.classList.contains('is-open'); }
  function open() { refreshCart();
    if (!root && !build()) return false;
    lastFocus = document.activeElement;
    root.removeAttribute('hidden');
    lock();
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); panel.focus({ preventScroll: true }); }); });
    setBurger(true);
    return true;
  }
  function close(noFocus) { 
    if (!isOpen()) return;
    root.classList.remove('is-open');
    unlock();
    setBurger(false);
    setTimeout(function () { if (!isOpen()) root.setAttribute('hidden', ''); }, 380);
    if (!noFocus && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function setBurger(on) {
    var s = document.querySelector('summary.header__icon--menu');
    if (s) s.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  // Take over the hamburger only on mobile widths; desktop untouched.
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('summary.header__icon--menu');
    if (!s || !MQ.matches) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var d = s.closest('details'); if (d) d.removeAttribute('open');
    if (isOpen()) close(); else open();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); close(); }
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('a[href],button,summary');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }, true);
  MQ.addEventListener && MQ.addEventListener('change', function () { if (!MQ.matches) close(true); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) close(true); });
})();
